import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Close from 'yoda-core-components/lib/assets/svg/CloseIcon_2022.svg';
import IconArrowLeftBlack from 'yoda-core-components/lib/assets/svg/left_arrow_2023.svg';
import HambCloseApollo from 'yoda-core-components/lib/assets/svg/CloseIcon_2022.svg';
import IconArrowLeftApollo from 'yoda-core-components/lib/assets/svg/IconArrowLeftApollo.svg';
import ScrollLockHOCFactory from 'yoda-core-components/lib/hoc/ScrollLockHOC/ScrollLockHOC';
import classNames from 'classnames/bind';
import _get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { enableFeatureInApp } from '../../helpers/Utils/features';
import * as nativeAppActions from '../../actions/NativeAppAction';
import * as ATCInterstitalActions from '../../actions/ATCInterstitalAction';
import SlidePanelContext from './SlidePanelContext';
import {
    ATC_HEADER_OPTIONS_ADDITIONAL_OPTIONS,
    ATC_HEADER_OPTIONS_DETAILS,
} from '../../common/Constants';
import * as styles from './SlidePanel.css';

const cx = classNames.bind(styles);

export class SlidePanel extends Component {
    static propTypes = {
        isOpenPanel: PropTypes.bool,
        onClosePanel: PropTypes.func.isRequired,
        onBackPanel: PropTypes.func, // updated this to handle this console warning Failed prop type: The prop `onBackPanel` is marked as required in `SlidePanel`, but its value is `undefined`.
        onCloseTransitionEnd: PropTypes.func,
        onOpenTransitionEnd: PropTypes.func,
        panelTitle: PropTypes.string,
        children: PropTypes.element,
        panelIcon: PropTypes.string,
        deviceType: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
        panelTitleAlignment: PropTypes.oneOf(['default', 'right', 'justified']),
        hideContentScroll: PropTypes.bool,
        enableExpandedAtc: PropTypes.bool,
        backButton: PropTypes.bool,
        panelTitleClass: PropTypes.string,
        theme: PropTypes.string,
        panelHeaderRenderer: PropTypes.func,
        panelContentTheme: PropTypes.string,
        cartSuccess: PropTypes.bool,
        cartAdditionalServices: PropTypes.bool,
        panelIconComponent: PropTypes.func,
        actions: PropTypes.object,
        isNative: PropTypes.bool,
        requestUrl: PropTypes.string,
        nativeCustomPanelHeader: PropTypes.string,
        enableFullViewPanel: PropTypes.bool,
        fromKA: PropTypes.bool,
        mobileAppWebViewBuildConfig: PropTypes.object,
        overlayStyleOverride: PropTypes.string,
        miniPDP: PropTypes.object,
        fromCouponSlider: PropTypes.bool,
        panelWidth: PropTypes.string,
    };

    static defaultProps = {
        isOpenPanel: false,
        panelTitle: '',
        children: '',
        panelIcon: 'arrow-left-black',
        panelIconComponent: <IconArrowLeftBlack />,
        panelTitleAlignment: 'default',
        onCloseTransitionEnd: null,
        onOpenTransitionEnd: null,
        deviceType: {},
        hideContentScroll: false,
        enableExpandedAtc: false,
        backButton: false,
        panelTitleClass: '',
        theme: '',
        panelHeaderRenderer: null,
        panelContentTheme: '',
        cartSuccess: false,
        cartAdditionalServices: false,
        onBackPanel: _noop, // // updated this to handle this console warning Failed prop type: The prop `onBackPanel` is marked as required in `SlidePanel`, but its value is `undefined`.
        actions: {},
        isNative: false,
        requestUrl: '',
        nativeCustomPanelHeader: '',
        enableFullViewPanel: false,
        fromKA: false,
        mobileAppWebViewBuildConfig: {},
        overlayStyleOverride: '',
        miniPDP: {},
        fromCouponSlider: false,
        panelWidth: '',
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.closePanel = this.closePanel.bind(this);
        this.backPanel = this.backPanel.bind(this);
        this.onCloseTransitionEnd = this.onCloseTransitionEnd.bind(this);
        this.onOpenTransitionEnd = this.onOpenTransitionEnd.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.state = {
            animateOnLoad: props.isOpenPanel,
            // This state represents if the panel was completely closed (after transition)
            closed: !props.isOpenPanel,
            showDetailSlider: false,
            detailSliderContent: '',
            couponDraw: false,
        };
    }

    componentDidMount() {
        if (!this.state.closed) {
            this.patchNativeHeader(false);
        }
        if (this.props.isNative) {
            document.removeEventListener('nativeAppBackPress', this.closePanel);
            document.addEventListener('nativeAppBackPress', this.closePanel);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpenPanel && !this.props.isOpenPanel) {
            this.setState({
                closed: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpenPanel !== this.props.isOpenPanel) {
            this.props.isOpenPanel ? this.patchNativeHeader(false) : this.patchNativeHeader(true);
        }
    }

    componentWillUnmount() {
        this.patchNativeHeader(true);
        if (this.props.isNative) {
            this.props.actions.ResetATCAddEdit();
            document.removeEventListener('nativeAppBackPress', this.closePanel);
        }
    }

    onOpenTransitionEnd() {
        if (typeof this.props.onOpenTransitionEnd === 'function') {
            this.props.onOpenTransitionEnd();
        }
        this.props.theme === 'couponDrawer' &&
            this.setState({
                couponDraw: false,
            });
    }

    onCloseTransitionEnd() {
        if (typeof this.props.onCloseTransitionEnd === 'function') {
            this.props.onCloseTransitionEnd();
        }
        this.props.theme === 'couponDrawer'
            ? this.setState({
                  closed: true,
                  couponDraw: true,
              })
            : this.setState({
                  closed: true,
              });
    }

    onTransitionEnd() {
        this.props.isOpenPanel ? this.onOpenTransitionEnd() : this.onCloseTransitionEnd();
    }

    getStyleToogleWrapper() {
        const toggleWrapperStyles = `${cx('toggleWrapper')} ${dt([
            'w-full',
            'h-full',
            'fixed',
            'sm:z-[99]',
            'top-0',
            'left-0',
            'bg-overlay-60',
            'opacity-0',
            'invisible',
        ])}`;
        const activeToggleWrapperStyles = `${cx('toggleWrapper')} ${dt([
            'w-full',
            'h-full',
            'fixed',
            'sm:z-[99]',
            'top-0',
            'left-0',
            'bg-overlay-60',
            'opacity-100',
            'visible',
        ])}`;

        const toogleWrapper = this.props.isOpenPanel
            ? activeToggleWrapperStyles
            : toggleWrapperStyles;
        return toogleWrapper;
    }

    getStyleTooglePanel() {
        const tooglePanel = this.props.isOpenPanel
            ? `${styles.detailsPanel} ${styles.activeDetailsPanel}`
            : this.state.couponDraw
            ? `${styles.detailsPanel} ${styles.animateOnClose}`
            : `${styles.detailsPanel}`;
        return tooglePanel;
    }

    closePanel(e) {
        const { isAddEditSlider: { isAddorEdit } = {}, isNative, fromCouponSlider } = this.props;
        e.preventDefault();
        if (isNative && this.state.showDetailSlider && (isAddorEdit || fromCouponSlider)) {
            this.setState({ showDetailSlider: false });
            this.backPanel(e);
        } else if (this.state.showDetailSlider) {
            this.setState({ showDetailSlider: false });
            this.props.onClosePanel(e);
        } else {
            this.props.onClosePanel(e);
        }
    }

    backPanel(e) {
        e.preventDefault();
        if (this.state.showDetailSlider) {
            setTimeout(() => {
                const itemElement = document.getElementById('couponDetailsId');
                if (itemElement) {
                    itemElement.scrollIntoView();
                }
            }, 1);
            this.setState({ showDetailSlider: false });
        } else {
            this.props.onBackPanel && this.props.onBackPanel(e);
        }
    }

    /* istanbul ignore next */
    showDetailSlider = (content) => {
        this.setState({ showDetailSlider: true, detailSliderContent: content });
    };

    getCartAtcHeaderText = () => {
        const { showDetailSlider } = this.state;
        const headerText = showDetailSlider
            ? ATC_HEADER_OPTIONS_DETAILS
            : ATC_HEADER_OPTIONS_ADDITIONAL_OPTIONS;
        return headerText;
    };

    cartATCPanelHeader = () => {
        let { backButton, cartAdditionalServices, fromCouponSlider, panelTitle } = this.props;
        const { showDetailSlider } = this.state;
        if (showDetailSlider) {
            backButton = true;
        }
        // Styling
        const panelHeaderStyle = dt([
            'backdrop-blur-sm',
            'bg-white',
            'text-black',
            'text-normal',
            'h-12',
            'lg:py-2',
            'smMd:py-3',
            'leading-tight',
            'w-full',
            'sm:z-[10]',
            'flex',
            'items-center',
            'border-b',
            'border-solid',
            'border-gray-15',
            'font-open-sans',
            'font-open-sans-bold',
        ]);
        const panelHeaderTextStyle = dt([
            'left-1/2',
            '-translate-x-1/2',
            'text-black',
            'absolute',
            'font-open-sans-semibold',
        ]);
        const closeIconStyle = dt(['sm:right-[18px]', 'inline-block']);
        let panelHeader = '';
        if (cartAdditionalServices) {
            panelHeader = this.getCartAtcHeaderText();
        } else if (fromCouponSlider) {
            panelHeader = !showDetailSlider && panelTitle;
        }
        // Styling
        return (
            <div className={`${cx('panelHeader')} ${panelHeaderStyle}`}>
                <>
                    {backButton && (
                        <a
                            href="javascript:void(0)"
                            className={cx('backIcon', 'panelBackIcon')}
                            onClick={this.backPanel}
                            data-automation-id="at-slide-back-button"
                        >
                            <Icon
                                iconType="svg"
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                                pathClassName={cx('panelIcon')}
                            >
                                <IconArrowLeftBlack />
                            </Icon>
                        </a>
                    )}
                    <span
                        data-automation-id="at-panel-title"
                        className={panelHeaderTextStyle}
                        tabIndex={-42}
                    >
                        {panelHeader}
                    </span>
                </>
                <a
                    href=""
                    className={`${closeIconStyle} ${dt(['absolute'])}`}
                    onClick={this.closePanel}
                    data-automation-id="at-primary-close-button"
                >
                    <Icon iconType="svg" width="24px" height="24px" viewBox="0 0 24 24">
                        <Close />
                    </Icon>
                </a>
            </div>
        );
    };

    patchNativeHeader(backButton = false) {
        this.props.isNative &&
            this.props.actions.patchHeader({
                backButton,
            });
    }

    renderPanelHeader = () => {
        const {
            panelTitleClass,
            panelHeaderRenderer,
            cartSuccess,
            cartAdditionalServices,
            panelIconComponent,
            requestUrl,
            deviceType,
            isNative,
            fromKA,
            fromCouponSlider,
        } = this.props;
        let { panelTitle, panelIcon, panelTitleAlignment, backButton } = this.props;
        let panelIconComp = panelIconComponent;
        if (cartAdditionalServices || fromCouponSlider) {
            return this.cartATCPanelHeader();
        }
        if (this.state.showDetailSlider) {
            panelTitle = '';
            panelIcon = 'close';
            panelIconComp = <Close />;
            panelTitleAlignment = 'justified';
            backButton = true;
        }
        const chooseOption = cartSuccess ? 'Choose Options' : '';
        // Styling
        const panelTitleStyle = dt(['inline-block', 'font-open-sans-bold', 'ml-2', 'leading-[2]']);
        const panelTitleKAStyle = dt(['inline-block', 'font-open-sans-bold', 'w-[90vw]']);
        return panelHeaderRenderer ? (
            panelHeaderRenderer()
        ) : (
            <div
                className={cx(styles.panelHeader, `panel-title-${panelTitleAlignment}`, {
                    miniPDPPanel: cartSuccess,
                })}
            >
                {!(isNative && requestUrl === '/') && (
                    <div className={dt(['text-large', 'h-8', 'flex', 'items-center'])}>
                        {chooseOption}
                    </div>
                )}
                {backButton && (
                    <a
                        href=""
                        className={cx('backButton', 'backIcon')}
                        onClick={this.backPanel}
                        data-automation-id="at-slide-backTo-button"
                    >
                        <Icon
                            iconType="svg"
                            width="18px"
                            height="18px"
                            viewBox="0 0 48 48"
                            pathClassName={dt(['fill-black'])}
                        >
                            <IconArrowLeftBlack />
                        </Icon>
                        <span
                            data-automation-id="at-panel-title"
                            className={`${panelTitleStyle} ${styles.panelTitle}`}
                            tabIndex={-42}
                        >
                            Back
                        </span>
                    </a>
                )}
                {fromKA ? (
                    <div className={cx('backIcon')} data-automation-id="at-slide-back-button">
                        <span
                            data-automation-id="at-panel-title"
                            className={cx('panelTitleKA', panelTitleClass, panelTitleKAStyle)}
                            tabIndex={-42}
                        >
                            {panelTitle}
                        </span>
                        <a className={cx(styles.buttonsBlock)} href="" onClick={this.closePanel}>
                            <Icon
                                iconType="svg"
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                                pathClassName={`${cx(panelIcon)} ${dt(['mr-1'])}`}
                            >
                                {panelIcon === 'arrow-left' ? (
                                    <IconArrowLeftBlack />
                                ) : (
                                    panelIconComp
                                )}
                            </Icon>
                        </a>
                    </div>
                ) : (
                    <a
                        href=""
                        className={cx('backIcon', 'miniPdpClose', { buttonsBlock: cartSuccess })}
                        onClick={this.closePanel}
                        data-automation-id="at-slide-back-button"
                    >
                        <Icon
                            iconType="svg"
                            viewBox="0 0 24 24"
                            width="24px"
                            height="24px"
                            pathClassName={styles.panelIcon}
                        >
                            {panelIcon === 'arrow-left' ? <IconArrowLeftBlack /> : panelIconComp}
                        </Icon>
                        <span
                            data-automation-id="at-panel-title"
                            className={`${cx('panelTitle', panelTitleClass)} ${dt(['ml-1'])}`}
                            tabIndex={-42}
                        >
                            {panelTitle}
                        </span>
                    </a>
                )}
            </div>
        );
    };

    renderPanelHeaderIosWebView = () => {
        const { panelTitleAlignment } = this.props;
        const closeIconStyle = dt(['sm:right-[18px]', 'inline-block']);
        return (
            <div className={cx(styles.panelHeader, `panel-title-${panelTitleAlignment}`)}>
                <a
                    href=""
                    className={`${closeIconStyle} ${dt(['ml-3'])}`}
                    onClick={this.closePanel}
                    data-automation-id="at-primary-close-button"
                >
                    <Icon iconType="svg" width="24px" height="24px" viewBox="0 0 24 24">
                        <HambCloseApollo />
                    </Icon>
                    <span
                        className={dt([
                            'font-open-sans-regular',
                            'ml-1',
                            'text-medium',
                            'text-black',
                        ])}
                    >
                        Close
                    </span>
                </a>
            </div>
        );
    };

    render() {
        const {
            theme,
            hideContentScroll,
            enableExpandedAtc,
            deviceType,
            overlayStyleOverride = '',
            panelContentTheme,
            isNative,
            requestUrl,
            enableFullViewPanel,
            mobileAppWebViewBuildConfig,
            fromKA,
            miniPDP,
            panelWidth,
        } = this.props;
        const contextValue = { showDetailSlider: this.showDetailSlider };
        const iosMinVersion = _get(mobileAppWebViewBuildConfig, 'bofHotFix1101.iosMinVersion', '');
        const canEnableFeature = iosMinVersion && enableFeatureInApp({ iosMinVersion });
        let isCheckoutIosApp = false;
        const showPaneHeader =
            !(isNative && requestUrl !== '/') || (isNative && requestUrl !== '/' && fromKA);
        /* istanbul ignore if */
        if (isNative && canEnableFeature && window.webkit) {
            const isCheckoutPresent = requestUrl.match(/\/checkout\//i);
            isCheckoutIosApp = isCheckoutPresent && isCheckoutPresent.length > 0;
        }
        // styling
        const panelContentStyle = dt([
            'overflow-auto',
            'overflow-x-hidden',
            'sm:z-[101]',
            isNative ? 'sm:h-full' : 'sm:h-[calc(100%-60px)]',
            'top-0',
            'relative',
        ]);
        const panelContentNoScrollStyle = dt([
            'sm:z-[101]',
            'h-full',
            'relative',
            'overflow-hidden',
        ]);

        const detailSliderContentAnimateBeforeStyles = dt([
            'pl-6',
            'pr-6',
            'pt-4',
            'w-full',
            'h-full',
            'absolute',
            'overflow-auto',
            'top-0',
            'sm:pb-10',
        ]);

        return (
            <div
                className={cx(theme, {
                    'mobile-exp': deviceType && deviceType.isMobile,
                    'tablet-exp': deviceType && deviceType.isTablet,
                    miniPDPSTLTheme: !isEmpty(miniPDP?.miniPDPSTL),
                })}
            >
                <button
                    className={[this.getStyleToogleWrapper(), overlayStyleOverride].join(' ')}
                    onClick={this.closePanel}
                />
                <div
                    data-automation-id="at-active-panel"
                    className={[
                        cx(
                            this.getStyleTooglePanel(),
                            enableExpandedAtc ? 'expandPanel' : '',
                            {
                                'animate-on-load': this.state.animateOnLoad,
                            },
                            enableFullViewPanel ? 'expandFullViewPanel' : ''
                        ),
                        panelWidth,
                    ].join(' ')}
                    onTransitionEnd={this.onTransitionEnd}
                    onAnimationEnd={this.onTransitionEnd}
                >
                    {showPaneHeader && this.renderPanelHeader()}
                    {isCheckoutIosApp && this.renderPanelHeaderIosWebView()}
                    {!this.state.closed ? (
                        <div
                            data-automation-id="at-panel-content"
                            id="atPanelContent"
                            className={cx([
                                hideContentScroll ? panelContentNoScrollStyle : panelContentStyle,
                                panelContentTheme,
                            ])}
                        >
                            <SlidePanelContext.Provider value={contextValue}>
                                <div
                                    className={`${cx(
                                        'main-slider-content-animate-before',
                                        this.state.showDetailSlider
                                            ? 'main-slider-content-animate-after'
                                            : ''
                                    )} ${dt(['w-full', 'h-full', 'visible'])}`}
                                >
                                    {this.props.children}
                                </div>
                                <div
                                    key={Math.random() * 100}
                                    className={`${detailSliderContentAnimateBeforeStyles} ${cx(
                                        'detail-slider-content-animate-before',
                                        this.state.showDetailSlider
                                            ? 'detail-slider-content-animate-after'
                                            : ''
                                    )}`}
                                >
                                    {this.state.detailSliderContent
                                        ? this.state.detailSliderContent
                                        : ''}
                                </div>
                            </SlidePanelContext.Provider>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        context: { isNative = false },
        context: { requestUrl = '' },
        isAddEditSlider,
        context: { preferences: { mobileAppWebViewBuildConfig = {} } = {} },
        miniPDP,
    } = state;
    return {
        isNative,
        requestUrl,
        isAddEditSlider,
        mobileAppWebViewBuildConfig,
        miniPDP,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...nativeAppActions,
            ...ATCInterstitalActions,
        },
        dispatch
    ),
});

export default ScrollLockHOCFactory('isOpenPanel')(
    connect(mapStateToProps, mapDispatchToProps)(SlidePanel)
);
